// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"21253165","235":"edc5ee51","313":"2389101c","515":"eea16386","555":"185ff1f8","638":"addafe46","856":"7deab32a"}[chunkId] + ".chunk.js";
};